export default "__VITE_ASSET__Ckf6KUp$__"